/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TwoDWaterLevel } from "./TwoDWaterLevel";
import {
  TwoDWaterLevelFromJSON,
  TwoDWaterLevelFromJSONTyped,
  TwoDWaterLevelToJSON,
  TwoDWaterLevelToJSONTyped,
} from "./TwoDWaterLevel";

/**
 *
 * @export
 * @interface PaginatedTwoDWaterLevelList
 */
export interface PaginatedTwoDWaterLevelList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<TwoDWaterLevel>;
}

/**
 * Check if a given object implements the PaginatedTwoDWaterLevelList interface.
 */
export function instanceOfPaginatedTwoDWaterLevelList(
  value: object
): value is PaginatedTwoDWaterLevelList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedTwoDWaterLevelListFromJSON(json: any): PaginatedTwoDWaterLevelList {
  return PaginatedTwoDWaterLevelListFromJSONTyped(json, false);
}

export function PaginatedTwoDWaterLevelListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedTwoDWaterLevelList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(TwoDWaterLevelFromJSON),
  };
}

export function PaginatedTwoDWaterLevelListToJSON(json: any): PaginatedTwoDWaterLevelList {
  return PaginatedTwoDWaterLevelListToJSONTyped(json, false);
}

export function PaginatedTwoDWaterLevelListToJSONTyped(
  value?: PaginatedTwoDWaterLevelList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(TwoDWaterLevelToJSON),
  };
}
